import * as React from "react";
import { Box, Radio, RadioGroup } from "@origin-digital/ods-core";
import { FieldProps, FormikProps, useFormikContext } from "formik";
import { IFormProps } from "../FormAccordionContainer";
import FormContext from "src/context/FormContext";
import { PropertyType as PropertyTypeEnum } from "src/components/Premises/types";

interface IPropertyTypeProps extends IFormProps {
  field: FormikProps<FieldProps>;
  isReadOnly: boolean;
}

const PropertyType = (props: IPropertyTypeProps) => {
  const { field, isReadOnly } = props;
  const { setFormState } = React.useContext(FormContext);
  const { setFieldValue } = useFormikContext();
  return (
    <RadioGroup
      {...field}
      id="property-type"
      name="propertyType"
      label="Property type"
      disabled={isReadOnly}
      onChange={(e) => {
        setFieldValue("propertyType", e.target.value);
        setFormState((prevState) => ({
          ...prevState,
          propertyType: e.target.value,
        }));
      }}
    >
      <Box
        display="flex"
        flexWrap="wrap"
        flexDirection={{
          xs: "column",
          sm: "column",
        }}
      >
        <Radio
          id="resi"
          label="Residential"
          value={PropertyTypeEnum.RESIDENTIAL}
        />
        <Radio
          id="comm"
          label="Commercial"
          value={PropertyTypeEnum.COMMERCIAL}
        />
      </Box>
    </RadioGroup>
  );
};

export default PropertyType;
